if (module.hot) {
  module.hot.accept();
}

import './js/_vendor';
import './js/_functions';
import './js/_components';
